export default "__VITE_ASSET__LOdkne3$__";